export type Gender = 'male' | 'female' | 'none';

export enum PronounType {
  /** The pronoun to use when the pronoun is the subject of a sentence, for
   * example "she found the ball" or "he found the ball" */
  subject = 'subject',
  /** The pronoun to use when referring to the pronoun in the sentence, for
   * example "I wonder about her" or "I wonder about him" */
  object = 'object',
  /** The pronoun to use when establishing the pronouns possession as an
   * adjective of something, for example "her ball" or "his ball" */
  possessive = 'possessive',
}

const pronouns: Record<Gender, Record<PronounType, string>> = {
  male: {
    [PronounType.subject]: 'he',
    [PronounType.object]: 'him',
    [PronounType.possessive]: 'his',
  },
  female: {
    [PronounType.subject]: 'she',
    [PronounType.object]: 'her',
    [PronounType.possessive]: 'her',
  },
  none: {
    [PronounType.subject]: 'they',
    [PronounType.object]: 'them',
    [PronounType.possessive]: 'their',
  },
};

/**
 * Return pronoun for a given gender and the type of pronoun.
 */
export function getPronoun(gender: Gender, type: PronounType): string {
  return pronouns[gender][type];
}
